import { NgModule } from '@angular/core';
import { EnvService } from './env.service';

@NgModule({
  providers: [EnvService],
})
export class EnvModule {}
